import { createSlice } from "@reduxjs/toolkit";
import { axios } from "@cores/axiosWrapper";
import { getWebhookHistoriesAPI } from "./apis/webhooks";
import extractApiError from "@utils/extract-api-error";

const initialState = {
    pending: false,
    error: null,
    data: [],
};

const webhookHistoriesSlice = createSlice({
    name: "webhookHistories",
    initialState,
    reducers: {
        resetWebhookHistories: () => initialState,
        pending(state) {
            state.pending = true;
            state.error = null;
        },
        success(state, action) {
            state.pending = false;
            state.error = null;
            state.data = action.payload;
        },
        failure(state, action) {
            state.pending = false;
            state.error = extractApiError(action.payload);
        },
    },
});

const { pending, success, failure } = webhookHistoriesSlice.actions;
export const { resetWebhookHistories } = webhookHistoriesSlice.actions;

/**
 * 웹훅 전송 이력 조회 (페이지 단위).
 * - status 는 서버 필터, limit / nextToken 으로 토큰 페이지네이션(한 페이지씩 조회).
 * - 응답(response)을 resolve 하여 호출 측이 response.data.nextToken 으로 페이지별 토큰을 관리한다.
 * @param {string} webhookId
 * @param {object} params - { status, limit, nextToken }
 * @param {AbortSignal} [signal]
 */
export const getWebhookHistories = (webhookId, params, signal) => (dispatch, getState) => {
    const { stage, project } = getState();
    dispatch(pending());
    return getWebhookHistoriesAPI(stage.id, stage.endpoint, project.id, webhookId, params, signal)
        .then((response) => {
            dispatch(success(response.data?.results ?? []));
            return response;
        })
        .catch((error) => {
            // 취소는 새 조회가 이어지는 경우라 에러 화면 대상이 아니다 — response 가 없어 status: null(Error500)로 표시되므로 거른다.
            if (!axios.isCancel(error)) dispatch(failure(error));
            throw error;
        });
};

export default webhookHistoriesSlice.reducer;
